module.exports = {
      id: "visual-story-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite.svg#visual-story",
      toString: function () {
        return this.url;
      }
    }